export const products = [
  {
    id: 'dottedmag-004',
    title: 'DOTTEDMAG 004 - HERITAGE',
    description: `Past.Present.Future - Heritage

Issue 004 - Heritage invites you on a reflective journey through the past, present, and future of football culture. As the game evolves, so do the ideas, systems, and identities that surround it.

This issue explores what heritage means in football—not as nostalgia, but as lineage, memory, philosophy, and transformation. With voices from across Africa, the Middle East, Asia, and Europe, this issue is global in its reach and personal in its storytelling. From changing fan identities and statistical revolutions, to the shrines of football and the faith behind the game, Heritage unpacks how football traditions are inherited, challenged, and reimagined through each generation.

Through striking visuals and original writing, Dotted.Mag 004 becomes more than a magazine—it's a time capsule and a compass.`,
    price: 35,
    image: '/images/shop/dottedmag-004-cover.jpg',
    imageTwo: '/images/shop/dottedmag-004.jpg',
    availability: 'IN STOCK',
    category: 'magazine',
  },
  {
    id: 'dottedmag-mini',
    title: 'DOTTEDMAG MINI',
    description: `Mini is a pocket-sized time capsule—a curated snapshot of the stories, cultures, and perspectives that have shaped Dotted.Mag over time.

Each Mini features a random selection of standout pages pulled from past issues, including Black Excellence, Motherland, Business, Heritage, and beyond. These stories explore football as more than just a game—examining its relationship with identity, culture, belief, rebellion, nostalgia, and change.

Whether you're receiving a story about Moroccan football philosophy, Pop Culture in Football, women's football in Jamaica, or statistical revolutions in Zagreb—you won't know which one you'll get until it lands in your hands. And that's the point.

Every Mini is different. Every Mini is intentional. A spark of inspiration. A quiet reminder. A bold perspective.`,
    price: 15,
    image: '/images/shop/dottedmag-mini.jpg',
    imageTwo: '/images/shop/dottedmag-mini.jpg',
    availability: 'IN STOCK',
    category: 'magazine',
  },
  {
    id: 'posters-004',
    title: '004 POSTERS',
    description: `A football cover. A football memory. A football culture. Framed.

The Dotted.Mag Poster Series reimagines our iconic front covers through the lens of heritage kits, legendary shirt patterns, and timeless colours. Each poster pays tribute not just to the game, but to the cultural symbols that shaped it — stripes that told a story, collars that defined an era, textures that made teams unforgettable.

This isn't just design — it's lineage on paper.

From sharp remakes inspired by Issue 004's minimalist mark to bold reinterpretations of classic kit culture, every print is a standalone piece — printed on heavyweight, matte-finish stock, ready to live on your wall.`,
    price: 10,
    image: 'https://pub-2a8ef6c8f46b4fea8bc3a9c339fb36cf.r2.dev/images/shop/posters-004.gif',
    imageTwo: 'https://pub-2a8ef6c8f46b4fea8bc3a9c339fb36cf.r2.dev/images/shop/posters-004.gif',
    availability: 'IN STOCK',
    category: 'print',
  },
  {
    id: 'dottedmag-001',
    title: 'DOTTEDMAG 001 - BLACK EXCELLENCE',
    description: `001 - 'BLACK EXCELLENCE' proudly shines a light on the remarkable Black professionals who thrived in the fiercely competitive world of the English Championship. This special edition takes you deep into the exhilarating 2019/20 season, exploring one of the most challenging leagues in football.

Through eleven detailed tactical profiles, we showcase the brilliance of emerging stars like Jude Bellingham at Birmingham City, the creative genius of Ebere Eze at QPR, and the attacking prowess of Ollie Watkins and Bryan Mbeumo at Brentford.

What tactical and analytical insights reveal how these exceptional players excelled in one of football's toughest divisions? Be inspired by these hidden heroes, whose tactical brilliance and impact extend far beyond the pitch.`,
    price: null,
    image: '/images/shop/dottedmag-001-cover.jpg',
    imageTwo: '/images/shop/dottedmag-001.jpg',
    availability: 'SOLD OUT',
    category: 'magazine',
  },
  {
    id: 'dottedmag-002',
    title: 'DOTTEDMAG 002 - BUSINESS',
    description: `Issue 002 - 'BUSINESS' delves into the complex realm of football economics, revealing how pivotal decisions off the pitch shape the drama on it.

Discover how the MLS business model has reshaped American football with its innovative approach to revenue and franchise stability. What makes Germany's 50+1 rule a unique safeguard for fan influence and competitive balance in the Bundesliga? How is China's 50-year plan poised to transform the nation into a global football powerhouse?

This issue provides a thorough exploration of the hidden forces that drive the game, offering a profound understanding of football's world beyond the final whistle.`,
    price: null,
    image: '/images/shop/dottedmag-002-cover.jpg',
    imageTwo: '/images/shop/dottedmag-002.jpg',
    availability: 'SOLD OUT',
    category: 'magazine',
  },
  {
    id: 'dottedmag-003',
    title: 'DOTTEDMAG 003 - MOTHERLAND',
    description: `Issue 003 - 'MOTHERLAND' takes you on an epic journey through the heart of African and Caribbean culture, where football serves as the universal language connecting worlds.

From the vibrant marketplaces of Accra to the rhythmic streets of Kingston, we delve into stories that span continents and cultures, uncovering the rich football traditions of Algeria, Barbados, Burkina Faso, Nigeria, Jamaica, Comoros, Equatorial Guinea, Montserrat, Ghana, South Africa, and beyond.

This issue is more than a celebration; it's a dynamic bridge linking the diaspora with those who remain in their ancestral lands. Through stunning visuals and compelling narratives, we reveal how the concept of Motherland weaves through both physical spaces and emotional ties.`,
    price: null,
    image: '/images/shop/dottedmag-003-cover.jpg',
    imageTwo: '/images/shop/dottedmag-003.jpg',
    availability: 'SOLD OUT',
    category: 'magazine',
  },
]
